import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13.3333C9.10457 13.3333 10 12.4378 10 11.3333C10 10.2287 9.10457 9.33325 8 9.33325C6.89543 9.33325 6 10.2287 6 11.3333C6 12.4378 6.89543 13.3333 8 13.3333Z",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.79958 10.0666C2.27906 9.5754 1.87851 8.971 1.62891 8.3002C1.37931 7.6294 1.28734 6.91018 1.36014 6.19816C1.43293 5.48614 1.66852 4.80041 2.04869 4.19399C2.42886 3.58758 2.94343 3.07674 3.55258 2.70097C4.16174 2.32521 4.84917 2.0946 5.56169 2.02698C6.27422 1.95936 6.99276 2.05653 7.66173 2.31099C8.3307 2.56546 8.93217 2.97038 9.41963 3.49445C9.90709 4.01853 10.2675 4.6477 10.4729 5.33331H11.6662C12.3022 5.34189 12.9189 5.55233 13.4274 5.93425C13.9359 6.31618 14.3099 6.84983 14.4954 7.45816C14.6809 8.06649 14.6682 8.71802 14.4593 9.31869C14.2503 9.91936 13.8559 10.4381 13.3329 10.8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4662 12.2666L9.86621 12.0667",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.1332 10.5999L5.5332 10.3999",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.06641 13.8L7.26641 13.2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.7334 9.4667L8.9334 8.8667",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.06647 13.8L8.7998 13.1333",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.20026 9.53337L6.93359 8.8667",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5332 12.4L6.19987 12.1333",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.7998 10.5333L10.4665 10.2666",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCloudAccount;
